"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sanitizeDescriptions = exports.hasQueryStringInURL = exports.getLanguage = exports.getDevicePixelRatio = exports.buildTranscriptHTML = void 0;
function buildTranscriptHTML(descriptions) {
    return function () {
        return descriptions.map(function (description) {
            var paragraph = document.createElement("p");
            paragraph.innerText = description;
            return paragraph;
        });
    };
}
exports.buildTranscriptHTML = buildTranscriptHTML;
function getDevicePixelRatio() {
    return devicePixelRatio || 1;
}
exports.getDevicePixelRatio = getDevicePixelRatio;
function getLanguage() {
    return document.documentElement.lang.toLowerCase().indexOf("en") > -1 ? "en" : "fr";
}
exports.getLanguage = getLanguage;
function hasQueryStringInURL(name) {
    var queryStrings = location.search.substring(1).split("&");
    return queryStrings.some(function (queryString) {
        var key = queryString.split("=")[0];
        return decodeURIComponent(key) === name;
    });
}
exports.hasQueryStringInURL = hasQueryStringInURL;
function sanitizeDescriptions(descriptions, formatTranscript) {
    return descriptions
        .reduce(function (uniqueDescriptions, currentDescription) {
        var text = currentDescription.text;
        return !uniqueDescriptions || uniqueDescriptions.map(function (description) { return description.text; }).indexOf(text) > -1
            ? uniqueDescriptions
            : uniqueDescriptions.concat(currentDescription);
    }, [])
        .sort(function (descriptionA, descriptionB) {
        if (descriptionA.startTime === descriptionB.startTime) {
            if (descriptionA.type === "caption" && descriptionB.type === "description") {
                return 1;
            }
            else if (descriptionB.type === "caption" && descriptionA.type === "description") {
                return -1;
            }
        }
        return descriptionA.startTime - descriptionB.startTime;
    })
        .map(function (currentDescription) {
        return formatTranscript ? formatTranscript(currentDescription.text) : currentDescription.text;
    });
}
exports.sanitizeDescriptions = sanitizeDescriptions;
//# sourceMappingURL=module.js.map